import { ValueFormatterParams } from '@ag-grid-community/core';
import { AgGridColumnDef, OrderSide } from '@tassat/common-definitions';
import { formatAsAsset } from '@tassat/utility';

export const getColumnDef = (orderType) => {
    const defaultCol: AgGridColumnDef[] = [
        {
            field: 'LastShares',
            headerName: 'Amount',
            minWidth: 100,
            menuTabs: [],
            valueFormatter: ((params: ValueFormatterParams) => formatAsAsset(params.value, params.context?.asset, 'ticker', undefined, true)),
            flex: 20
        },
        {
            field: 'ExecutionPrice',
            headerName: 'Execution Price',
            minWidth: 120,
            menuTabs: [],
            valueFormatter: ((params: ValueFormatterParams) => formatAsAsset(params.value)),
            flex: 12
        },
        {
            field: 'ExecutionId',
            headerName: 'Execution ID',
            cellRenderer: 'userStatusCellRenderer',
            minWidth: 120,
            menuTabs: [],
            flex: 15
        },
        {
            field: 'ExecutionTime',
            headerName: 'Execution Time',
            cellRenderer: 'dateCellRender',
            menuTabs: [],
            minWidth: 120,
            flex: 15
        }
    ];

    if (orderType && (orderType === OrderSide.REDEEM || orderType === OrderSide.SELL)) {
        defaultCol.push(
            {
                field: 'CostBasis',
                headerName: 'Cost Basis',
                width: 120,
                minWidth: 120,
                menuTabs: [],
                valueFormatter: ((params: ValueFormatterParams) => formatAsAsset(params.value)),
                flex: 1
            },
            {
                field: 'TotalCost',
                headerName: 'Total Cost',
                width: 120,
                minWidth: 120,
                menuTabs: [],
                valueFormatter: ((params: ValueFormatterParams) => formatAsAsset(params.value)),
                flex: 1
            },
            {
                field: 'TotalProceeds',
                headerName: 'Total Proceeds',
                width: 120,
                minWidth: 120,
                menuTabs: [],
                valueFormatter: ((params: ValueFormatterParams) => formatAsAsset(params.value)),
                flex: 1
            }
        );
    }

    return defaultCol;
};